import React from 'react';
import './ServicesVideo.scss';
import { Col, Row } from 'antd';
import { IoMdArrowDropright } from 'react-icons/io';

const ServicesVideo = ({ t }) => {
  return (
    <div className="services-video">
      <div className="container">
        <div
          className="content"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          {/* <Row gutter={[20, 20]}> */}
          {/* <Col sm={24} md={24} lg={10} xl={10} xxl={10}> */}
          <div className="info-video">
            <h2 className="title-services-video">{t.Howwework}</h2>
            <p className="text-services-video">{t.textServicVideo}</p>
          </div>
          {/* </Col> */}
          {/* <Col sm={24} md={24} lg={14} xl={14} xxl={14}>
                   <div className="video">
                    
                    <IoMdArrowDropright/>
                   </div>
                    </Col> */}
          {/* </Row> */}
        </div>
      </div>
    </div>
  );
};

export default ServicesVideo;
